module.exports = __webpack_public_path__ + "static/media/explorer.82e8607a.svg";